import React, { ReactElement } from "react";
import { toLiteral } from "../../../helper/locale-utils";
import Notification, { NotificationBody, NotificationHeader } from "@adeccoux/tag-ds/notification";

const LoadingMessage: React.FC<any> = (props): ReactElement => {
  return (
    <Notification className="notification_relative" renderAsPortal={false} data-testid="notification" show={true} info={true}>
      <NotificationHeader>{toLiteral({ id: "Loading" })}</NotificationHeader>
      <NotificationBody>{toLiteral({ id: "Please wait" })}</NotificationBody>
    </Notification>
  );
};

export default LoadingMessage;
